<ng-container *ngIf="isWokHey; else commonSpinner">
  <ngx-spinner
    [fullScreen]="false"
    bdColor="#fff"
    template="<img src='{{
      animationImage
    }}' style='height: auto;width: 370px;' />"
  >
  </ngx-spinner>
</ng-container>

<ng-template #commonSpinner>
  <ngx-spinner
    [fullScreen]="false"
    bdColor="{{ alternateColor }}"
    template="<img src='{{ animationImage }}' style='height: 200px;' />"
  >
  </ngx-spinner>
</ng-template>

<ng-container *ngIf="preloader; else showRoute">
  <app-preloader @fade></app-preloader>
</ng-container>

<div class="container">
  <ng-template #showRoute>
    <router-outlet></router-outlet>
  </ng-template>

  <ng-container *ngIf="!hideBranding">
    <div class="edine-by-levelfive" *ngIf="!preloader">
      <span
        >eDine -&nbsp;Powered by -&nbsp;<a
          href="https://hashmato.com"
          target="_blank"
          >Hashmato</a
        >
      </span>
    </div>
  </ng-container>
</div>

<section class="fixed-area side-bar-area" *ngIf="loginRequired || forceLogin">
  <header>
    <!-- Navbar Left -->
    <nav class="navbar navbar-2 menu-bar" [style.background]="baseColor">
      <div class="navbar-left mr-auto" (click)="toggleMenu()">
        <div class="hamburger-menu" [class.active]="toggleLeftMenu">
          <div class="bar-top"></div>
          <div class="bar-middle"></div>
          <div class="bar-bottom"></div>
        </div>
      </div>
    </nav>

    <!-- Side Menu -->
    <div class="side__menu" [style.display]="toggleLeftMenu ? 'block' : 'none'">
      <ul class="__go-in">
        <ng-container *ngIf="loginRequired">
          <li *ngIf="externalMember?.id && externalMember?.name; else showSignIn">
            <div class="external-member-badge">
              <span class="label">Member:</span>
              <span class="name">{{ externalMember.name }}</span>
              <i class="pi pi-times close-icon" (click)="logoutExternalMember()" title="Logout"></i>
            </div>
          </li>

          <!-- Fallback to sign in -->
          <ng-template #showSignIn>
            <li *ngIf="!isLoggedIn">
              <a class="cursor-pointer" (click)="login()">
                <span [innerHtml]="'signIn' | translate">Sign In</span>
              </a>
            </li>
          </ng-template>

          <li *ngIf="!isLoggedIn && !hideSignup">
            <a class="cursor-pointer" (click)="signUp()"><span [innerHtml]="'signUp' | translate">Sign Up</span></a>
          </li>
        </ng-container>
      </ul>

      <ul class="__explore">
        <!-- Enhanced Language Selector -->
        <li class="language-selector-item">
          <div class="language-selector">
            <div class="select-wrapper">
              <select [value]="currentLang" (change)="setLang($event)" class="lang-dropdown"
                [attr.aria-label]="'Select language'">
                <option *ngFor="let lang of languages" [value]="lang.code">
                  {{ lang.label }}
                </option>
              </select>
              <div class="select-icon">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                  <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </li>

        <li *ngIf="isLoggedIn && loggedInUser?.balance">
          <div class="user-info-card">
            <div class="info-row">
              <span class="label">User Balance:</span>
              <span class="value">
                {{ setupCurrency }}&nbsp;{{ loggedInUser?.balance?.balance | number:'1.2-2' }}
              </span>
            </div>
          </div>
        </li>

        <li *ngIf="isShowMenu.profile">
          <a href="javascript:" (click)="gotoProfile()"><span [innerHtml]="'profile' | translate">Profile</span></a>
        </li>

        <li>
          <a href="javascript:" (click)="gotoHome()"><span [innerHtml]="'home' | translate">Home</span></a>
        </li>

        <li *ngIf="!serviceSetup && !isDineIn">
          <a href="javascript:" (click)="gotoLocations()" *ngIf="isShowMenu?.location">
            <span [innerHtml]="'locations' | translate">Location(s)</span>
          </a>
        </li>

        <li *ngIf="selectedLocationId && !serviceSetup && !isDineIn">
          <a href="javascript:" (click)="gotoDepartments()">
            <span>{{
              isShowPreorder ? "Pre-order" : ("departments" | translate)
              }}</span>
          </a>
        </li>

        <li *ngIf="isLoggedIn" (click)="toggleMenu()" [routerLink]="['/' + tenantCode + '/order/order-history']">
          <a href="javascript:">
            <span [innerHtml]="'orderHistory' | translate">Order History</span>
          </a>
        </li>

        <li *ngIf="isLoggedIn">
          <a class="cursor-pointer" (click)="changePassword()">
            <span>{{"changePassword" | translate}}</span>
          </a>
        </li>

        <li *ngIf="isLoggedIn">
          <a href="javascript:" (click)="logout()"><span [innerHtml]="'logout' | translate">Log Out</span></a>
        </li>
      </ul>
    </div>
  </header>
</section>
